import SliceNames from '@/state/enum';
import { RefState } from '@/state/slices/ref/typings';

const refState: RefState = {
	[SliceNames.REF]: {
		refs: [],
	},
};

export default refState;
